module.exports = __webpack_public_path__ + "static/media/cgu_20240531.3456c31d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/cgu_20240531.pdf
// module id = 2303
// module chunks = 0